import {sample} from 'lodash';

const noise = '?[]!@#$%^&*()-=+_'.split('');

export function encrypt(value: string) {
  return value.split('').map(char => {
    return char.charCodeAt(0).toString().concat(sample(noise) ?? '');
  }).join('');
}

export function decrypt(value: string) {
  return value.match(/\d+/g)?.map(code => String.fromCharCode(parseInt(code))).join('');
}
